import { getCookies, checkCookiesList } from 'helpers/utils';

if (document.querySelector('.header-notifications')) {
    const container = document.querySelector('.header-notifications');
    const notifications = container.querySelectorAll('.header-notification');
    let hiddenNotifications;
    let notiticationsAmount;
    let cookies = [];

    window.addEventListener('load', function () {
        getCookies('nc', cookies);
        notifications.forEach((notification) => {
            checkCookiesList(cookies, notification);
            notification
                .querySelector('.close-header-notification i')
                .addEventListener('click', function () {
                    document.cookie = `${this.dataset.cookie}=nc`;
                    notiticationsAmount--;
                    container.classList.add('notifications-' + notiticationsAmount);
                    notification.classList.add('has-cookie');
                });
        });

        hiddenNotifications = container.querySelectorAll('.has-cookie');
        notiticationsAmount = notifications.length - hiddenNotifications.length;
        container.classList.add('notifications-' + notiticationsAmount);

        setTimeout(function () {
            container.classList.add('display-header-notifications');
        }, 100);
        let currentActive = 0;
        for (let i = 0; i < notifications.length; i++) {
            if (!notifications[i].classList.contains('has-cookie')) {
                currentActive++;
                setTimeout(function () {
                    notifications[i].classList.add('header-notifications-show');
                }, currentActive * 400);
            }
        }
    });
}
